var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 54,
    viewBox: "0 0 42 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 24C23.3734 24 25.6935 23.2962 27.6668 21.9776C29.6402 20.6591 31.1783 18.7849 32.0866 16.5922C32.9948 14.3995 33.2324 11.9867 32.7694 9.65892C32.3064 7.33115 31.1635 5.19295 29.4853 3.51472C27.8071 1.83649 25.6689 0.693605 23.3411 0.230582C21.0133 -0.232441 18.6005 0.00519937 16.4078 0.913451C14.2151 1.8217 12.3409 3.35977 11.0224 5.33316C9.70379 7.30655 9 9.62663 9 12C9 15.1826 10.2643 18.2348 12.5147 20.4853C14.7652 22.7357 17.8174 24 21 24ZM39 54C39.7957 54 40.5587 53.6839 41.1213 53.1213C41.6839 52.5587 42 51.7957 42 51C42 45.4305 39.7875 40.089 35.8492 36.1508C31.911 32.2125 26.5695 30 21 30C15.4305 30 10.089 32.2125 6.15076 36.1508C2.21249 40.089 8.29927e-08 45.4305 0 51C0 51.7957 0.316071 52.5587 0.87868 53.1213C1.44129 53.6839 2.20435 54 3 54H39Z",
    fill: "url(#paint0_linear_12_461)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_461",
    x1: 20.5508,
    y1: 41.58,
    x2: -15.2746,
    y2: 36.4558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.120b200484d547c961e219d90be72a19.svg";
export { ForwardRef as ReactComponent };